export class RenewErrorHandler {
    constructor(userInfo, eventsManager) {
        this.userInfo = userInfo;
        this.eventsManager = eventsManager;
    }
    handleError(error) {
        console.warn(error);
        this.handleMessage(error.message);
        this.userInfo.logout();
    }
    handleMessage(message) {
        if (message === "TIME_LIMIT_REACHED") {
            this.eventsManager.dispatchEvent("onTimeLimitReached", undefined, true);
        }
        else {
            this.userInfo.showSessionExpired();
        }
    }
}
//# sourceMappingURL=RenewErrorHandler.js.map